import PageLayout from "@/components/feature/PageLayout";
import usePageMeta from "@/hooks/usePageMeta";
import HeroCarousel from "./components/HeroCarousel";
import CategoryStrip from "./components/CategoryStrip";
import LatestSection from "./components/LatestSection";
import HotSection from "./components/HotSection";
import NewsSection from "./components/NewsSection";
import IntroBand from "./components/IntroBand";

export default function Home() {
  usePageMeta({
    title: "秋霞电影-最新电影资讯与影视内容聚合平台",
    description:
      "秋霞电影为您提供丰富的电影资讯、电影推荐及影视内容聚合，涵盖各种类型电影，方便用户了解最新电影动态和相关影视作品。",
    keywords: "秋霞电影,电影资讯,影视内容,电影推荐,最新电影,电影动态,电影平台",
  });

  return (
    <PageLayout>
      <HeroCarousel />
      <CategoryStrip />
      <LatestSection />
      <HotSection />
      <NewsSection />
      <IntroBand />
    </PageLayout>
  );
}